import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@core-ui/Components/ui/dialog';
import { useTranslation } from 'react-i18next';
import { Button } from '@core-ui/Components/ui/button';
import { AlertTriangle } from 'lucide-react';

interface DiscardIntentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export const DiscardIntentDialog: React.FC<DiscardIntentDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-2xl shadow-lg border border-border bg-card text-foreground p-6">
        <DialogHeader className="mb-2">
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center justify-center h-9 w-9 rounded-full border border-destructive/30 bg-destructive/10 text-destructive">
              <AlertTriangle className="h-5 w-5" />
            </span>
            <DialogTitle>
              {t('intent.discardChangesDialog.title')}
            </DialogTitle>
          </div>
        </DialogHeader>

        <DialogDescription asChild>
          <div className="text-sm leading-relaxed text-muted-foreground">
            <p className="text-sm text-muted-foreground">
              {t('intent.discardChangesDialog.description')}
            </p>
          </div>
        </DialogDescription>

        <div className="flex justify-end gap-2 mt-6">
          <Button
            data-qa-id="intent-cancel-delete-button"
            variant="outline"
            className="border border-border text-muted-foreground hover:bg-muted"
            onClick={() => {
              onOpenChange(false);
            }}
          >
            {t('intent.discardChangesDialog.continueEditing')}
          </Button>
          <Button
            variant="destructive"
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
          >
            {t('intent.discardChangesDialog.confirm')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};